import { AppScaffold } from '../components/AppScaffold.jsx';
import { useKUniRuntime } from '../hooks/useKUniRuntime.js';

export function App() {
  useKUniRuntime();
  return <AppScaffold />;
}
